enum WindowCloseReason {
  SuccessfullyPaired = 0,
  CriticalFail = 1,
  UserCancel = 2,
}

export default WindowCloseReason;



// WEBPACK FOOTER //
// ./src/enums/WindowCloseReason.ts